import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { TranslocoPipe } from '@jsverse/transloco';

import confetti from 'canvas-confetti';
import {Router} from '@angular/router';
import {User, UserRoles} from '../../entities/user/user.entity';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import { DatePipe } from '@angular/common';
import {RegisterComponent} from '../register/register.component';
import {LocalStorageService} from '../../services/localstorage/local-storage.service';
import {catchError, of, switchMap, takeWhile, tap, timer} from 'rxjs';

@Component({
  selector: 'app-register-success',
  imports: [TranslocoPipe, DatePipe],
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'scale(0.8) rotateX(20deg)',  // Start slightly tilted and smaller
        }),
        animate(
          '1s 1s ease-out',  // 1s delay before starting, 1s animation duration
          style({
            opacity: 1,
            transform: 'scale(1) rotateX(0deg)',  // End at full size and flat
          })
        ),
      ]),
    ]),
  ],
})
export class RegisterSuccessComponent implements OnInit {
  public user: User|null = null;
  public now: Date;

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly localStorage: LocalStorageService,
  ) {
    this.now = new Date();
  }

  public ngOnInit() {
    this.user = this.authenticationService.getCurrentUser();
    const initialPlan = this.user?.subscriptionPlan ?? null;
    const pollStart = Date.now();
    const maxPollDurationMs = 15000;
    timer(0, 2000).pipe(
      switchMap(() => this.authenticationService.refreshToken().pipe(catchError(() => of(null)))),
      tap(() => {
        this.user = this.authenticationService.getCurrentUser();
      }),
      takeWhile(() => {
        const hasPlanChanged = (this.user?.subscriptionPlan ?? null) !== initialPlan;
        const timedOut = (Date.now() - pollStart) >= maxPollDurationMs;
        return !hasPlanChanged && !timedOut;
      }, true),
    ).subscribe();
    // Trigger confetti animation when the page loads
    setTimeout(() => {
      confetti({
        particleCount: 200, // Number of confetti particles
        spread: 180, // How far the confetti spreads
        origin: { y: 0.6 }, // Where the confetti starts
        colors: ['#ffd700', '#ffcc00', '#f4a300', '#cfa900'],
        scalar: 1.2, // Adjust the size of the particles
      });
    }, 1000); // Delay to allow the page animation to complete

    this.localStorage.remove(RegisterComponent.localStorageKey);
  }

  public redirect(): void {
    if (this.user?.roles.includes(UserRoles.photographer)) {
      this.router.navigate(['/manage/onboarding']);
      return;
    }
    this.router.navigate(['/']);
    return;
  }

  public planDisplayName(): string {
    return this.user?.subscriptionPlanLabel ?? 'Shutterflow Free';
  }

}
